import { cn } from '@/lib/core';
import { ProductView } from '.';

export function ShopProductListInfo({
  title,
  description,
  view,
}: {
  title?: string;
  description?: string;
  view: ProductView;
}) {
  if (!title && !description) return null;
  const isV1 = view === 1;
  return (
    <div
      className={cn(
        'flex flex-col px-4 pt-6',
        isV1 ? 'gap-2 pb-2' : 'border-jncquoi-neutral-200 gap-2.5 border-b pb-8'
      )}
    >
      {title && (
        <p className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[14px] leading-none font-semibold tracking-[0.5px] uppercase">
          {title}
        </p>
      )}
      {description && (
        <div
          className={cn(
            'font-pp-neue-montreal text-jncquoi-neutral-1000 leading-normal!',
            isV1 ? 'text-[20px]' : 'text-[16px] tracking-[0.25px]'
          )}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
    </div>
  );
}
